/* ============================================================================
   TREATONIC — Sales page interactivity  ·  treatonic-sales.js
   ========================================================================= */
(function(){
  'use strict';
  function init(){
    if(window.__txSalesInit) return;
    if(!document.querySelector('.tx-sales')) return;
    window.__txSalesInit = true;
    var root = document; /* sections each wrap in .tx-sales; query across all of them */

    /* 给当前所有 .tx-sales 区块加上 .tx-animate：CSS 的隐藏态以此为开关。
       这样未被处理的区块默认可见，不会卡在 opacity:0（见下方 section:load 处理）。 */
    [].slice.call(document.querySelectorAll('.tx-sales')).forEach(function(s){ s.classList.add('tx-animate'); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- shared scroll scheduler ----------
     把本文件内的滚动相关计算收敛到一个 rAF 队列，避免原生 smooth scroll 期间
     多个监听器重复读 layout。Dawn 自带 header 监听仍由主题本身管理。 */
  var scrollJobs = [];
  var scrollRaf = 0;
  function runScrollJobs(){
    scrollRaf = 0;
    scrollJobs.forEach(function(job){ job(); });
  }
  function scheduleScrollJobs(){
    if(scrollRaf){ return; }
    scrollRaf = requestAnimationFrame(runScrollJobs);
  }
  function addScrollJob(job){
    if(typeof job === 'function'){ scrollJobs.push(job); }
  }
  window.addEventListener('scroll', scheduleScrollJobs, { passive: true });
  window.addEventListener('resize', scheduleScrollJobs, { passive: true });

  /* ---------- scroll reveal ----------
     Scroll/resize visibility check (not IntersectionObserver, which can fail to
     fire inside some embedded/theme-editor contexts and would leave .reveal
     elements stuck at opacity:0). Reveals what's in view on load, the rest on scroll. */
  var reveals = [].slice.call(root.querySelectorAll('.reveal'));
  if(reduce){
    reveals.forEach(function(el){ el.classList.add('in'); });
  } else {
    var rvInView = function(el){
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h * 0.92 && r.bottom > 0;
    };
    var rvTick = function(){
      for(var i = reveals.length - 1; i >= 0; i--){
        if(rvInView(reveals[i])){ reveals[i].classList.add('in'); reveals.splice(i, 1); }
      }
    };
    addScrollJob(function(){ if(reveals.length){ rvTick(); } });
    rvTick();
    // safety net: if scroll events never arrive (some embedded contexts), never
    // leave content stuck at opacity:0 — force-reveal whatever remains after 4s.
    setTimeout(function(){ reveals.slice().forEach(function(el){ el.classList.add('in'); }); reveals.length = 0; }, 4000);
  }

  /* ---------- pricing tiers: visual selection ---------- */
  var tiers = [].slice.call(root.querySelectorAll('.tier'));
  var TIER_DATA = {
    '0': { now:'$49.99', was:'',        save:'' },
    '1': { now:'$74.95', was:'$99.98',  save:'Save 25%' },
    '2': { now:'$99.95', was:'$149.97', save:'Save 33%' }
  };
  var currentIndex = 1;  // default = 2-month (most popular)
  var bbNow = root.querySelector('#bbNow'), bbWas = root.querySelector('#bbWas'),
      bbSave = root.querySelector('#bbSave'), bbBtnPrice = root.querySelector('#bbBtnPrice');

  function setBuyBarTier(index){
    var d = TIER_DATA[index] || TIER_DATA['1'];
    if(bbNow) bbNow.textContent = d.now;
    if(bbBtnPrice) bbBtnPrice.textContent = d.now;
    if(bbWas){ bbWas.textContent = d.was; bbWas.style.display = d.was ? '' : 'none'; }
    if(bbSave){ bbSave.textContent = d.save; bbSave.style.display = d.save ? '' : 'none'; }
  }

  function selectTier(tier){
    tiers.forEach(function(t){ t.classList.remove('featured'); });
    tier.classList.add('featured');
    var cta = tier.querySelector('.tier-cta');
    if(cta){ currentIndex = parseInt(cta.getAttribute('data-bundle-index'), 10) || 0; setBuyBarTier(currentIndex); }
  }

  /* ---------- add to cart → Shopify AJAX /cart/add.js ----------
     The custom buy box has taken over add-to-cart. We add via /cart/add.js
     (the only method that reliably adds, returns a result we can react to, and
     is auto-intercepted by the cart-drawer app — Kaching / Slide Cart — so the
     drawer opens by itself). We REPLICATE the native Kaching bundle lines:
     main product (quantity = pack count) + the free Nail Clipper Kit gift,
     both carrying the __kaching_bundles property with a shared grouping token,
     so the automatic discount recognises the signature and zeroes the gift.
     We never submit a hidden /cart/add form and never click BUY NOW (Shop Pay). */
  var MAIN_VARIANT = window.TX_MAIN_VARIANT || 42013880123427;     // 2-Step Kit
  var GIFT_VARIANT = window.TX_GIFT_VARIANT || 42452011876387;     // Nail Clippers
  var KB_DEAL = 'iESN';   // Kaching deal id (shared)
  var KB_GIFT = 'Ic8W';   // gift id (shared)
  // per-tier: pack quantity, Kaching bar id (bid), and whether the free gift attaches
  var BUNDLE_DATA = {
    '0': { qty:1, bid:'G67s', gift:false },   // 1-Month  $49.99  (no gift)
    '1': { qty:2, bid:'7e0M', gift:true  },   // 2-Month  $74.95  + free clipper
    '2': { qty:3, bid:'wCA7', gift:true  }    // 3-Month  $99.95  + free clipper
  };

  function kbToken(){
    // 4-char grouping token (matches the native LvlO / Qa16 / NbYJ style),
    // shared between the main line and its gift line.
    var c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', t = '';
    for(var i=0;i<4;i++){ t += c.charAt(Math.floor(Math.random()*c.length)); }
    return t;
  }

  function buildItems(index, src){
    var d = BUNDLE_DATA[index] || BUNDLE_DATA['1'];
    var token = kbToken();
    var items = [{
      id: MAIN_VARIANT,
      quantity: d.qty,
      // _src：埋点，记录客人点的是哪个按钮（sticky / tier-N）；下划线开头在 checkout 对客人隐藏
      properties: { __kaching_bundles: JSON.stringify({ deal:KB_DEAL, main:true, id:token, bid:d.bid }), _src: src || 'unknown' }
    }];
    if(d.gift){
      items.push({
        id: GIFT_VARIANT,
        quantity: 1,
        properties: { __kaching_bundles: JSON.stringify({ id:token, deal:KB_DEAL, gift:KB_GIFT }) }
      });
    }
    return items;
  }

  // open the cart drawer if the app exposes a trigger (most apps auto-open on
  // /cart/add.js; this is a best-effort fallback so we never silently stall).
  function openCartDrawer(){
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
    document.dispatchEvent(new CustomEvent('cart:build',   { bubbles:true }));
    var trigger = document.querySelector(
      '[data-cart-drawer-toggle], [data-drawer-toggle="cart"], .js-drawer-open-cart, ' +
      'a[href="/cart"][data-drawer], #cart-icon-bubble, .header__icon--cart, .cart-toggle'
    );
    if(trigger){ try { trigger.click(); } catch(e){} }
  }

  function setBtnState(btn, label, on){
    if(!btn) return;
    if(on && !btn.hasAttribute('data-html')){ btn.setAttribute('data-html', btn.innerHTML); }
    if(label != null){ btn.textContent = label; }
    btn.classList.toggle('is-adding', !!on);
    btn.style.pointerEvents = on ? 'none' : '';
  }
  function restoreBtn(btn){
    if(!btn) return;
    var orig = btn.getAttribute('data-html');
    if(orig != null){ btn.innerHTML = orig; btn.removeAttribute('data-html'); }
    btn.classList.remove('is-adding');
    btn.style.pointerEvents = '';
  }

  function addToCart(index, btn, src){
    setBtnState(btn, 'Adding…', true);   // instant synchronous feedback
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: buildItems(index, src) })
    })
    .then(function(r){ if(!r.ok){ throw new Error('add failed ' + r.status); } return r.json(); })
    .then(function(){
      if(btn){ setBtnState(btn, 'Added ✓', false); setTimeout(function(){ restoreBtn(btn); }, 1400); }
      openCartDrawer();
    })
    .catch(function(err){
      if(window.console){ console.warn('[Treatonic] /cart/add.js failed:', err); }
      restoreBtn(btn);
      // fallback: only redirect when we are actually on a storefront (not the
      // local design preview, where /cart 404s).
      if(/myshopify\.com$/.test(location.hostname) || document.querySelector('body.template-product, [data-shopify]')){
        window.location.href = '/cart';
      }
    });
  }

  tiers.forEach(function(tier){
    tier.addEventListener('click', function(){ selectTier(tier); });
  });
  [].slice.call(root.querySelectorAll('.tier-cta')).forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var tier = btn.closest('.tier');
      if(tier){ selectTier(tier); }
      var idx = parseInt(btn.getAttribute('data-bundle-index'), 10) || 0;
      addToCart(idx, btn, 'tier-' + idx);
    });
  });

  /* ---------- sticky Add to Cart bar ----------
     Pinned to the bottom on scroll; hidden over the hero and over the final
     CTA / footer area. Its button adds the currently-selected tier via /cart/add.js. */
  var buyBar = root.querySelector('#txBuyBar');
  var bbCta  = root.querySelector('#bbCta');
  var heroEl = root.querySelector('.hero');
  var closerEl = root.querySelector('.closer');
  /* iPhone Safari 的动态视口原点会被顶部地址栏向下推；加 class 让 CSS 使用
     稳定的大视口底边。iPhone Chrome（CriOS）继续使用动态视口。 */
  var ua = navigator.userAgent || '';
  var isIOSSafari = /iP(?:hone|ad|od)/.test(ua) &&
    /WebKit/.test(ua) &&
    !/(CriOS|FxiOS|EdgiOS|OPiOS)/.test(ua);
  document.documentElement.classList.toggle('tx-ios-safari', isIOSSafari);
  setBuyBarTier(currentIndex);
  if(bbCta){
    bbCta.addEventListener('click', function(e){ e.preventDefault(); addToCart(currentIndex, bbCta, 'sticky'); });
  }
  /* 页面上任一"加购/选档"主 CTA（tx2 hero 的 ADD TO CART、tx-pricing 档位卡 CTA、
     Kaching 原生按钮）出现在视口内时收起 bar——同屏永远只有一个主按钮 */
  var ATC_SELECTOR = [
    '[data-tx2-cta]',
    '.tier-cta',
    '.kaching-bundles__block button',
    'button[name="add"]',
    '[data-add-to-cart]',
    '.product-form__submit'
  ].join(',');
  function atcOnScreen(){
    var els = document.querySelectorAll(ATC_SELECTOR);
    var vv = window.visualViewport;
    /* rect 坐标相对布局视口；iOS 工具栏展开/收起时，用 visualViewport
       的真实上下边界，不能用经常滞后的 window.innerHeight。 */
    var viewTop = vv ? vv.offsetTop : 0;
    var viewBottom = viewTop + (vv ? vv.height : (document.documentElement.clientHeight || window.innerHeight));
    for(var i = 0; i < els.length; i++){
      var el = els[i];
      if(el.closest('#txBuyBar') || !el.getClientRects().length) continue;
      var r = el.getBoundingClientRect();
      /* 只要顾客能看到按钮的任意一部分，就立即隐藏 Choose Your Kit。 */
      if(r.height > 0 && r.bottom > viewTop && r.top < viewBottom){ return true; }
    }
    return false;
  }
  var lastShow = null;
  function updateBuyBarVis(){
    if(!buyBar) return;
    var pastHero = heroEl ? (heroEl.getBoundingClientRect().bottom < 60) : (window.pageYOffset > 500);
    var closerVisible = false;
    if(closerEl){ var r = closerEl.getBoundingClientRect(); closerVisible = r.top < (window.innerHeight - 40); }
    var clickScrollActive = Date.now() < (window.__txBuyBarSuppressUntil || 0);
    var show = pastHero && !closerVisible && !clickScrollActive && !atcOnScreen();
    if(show === lastShow) return;               /* 状态没变就不碰 DOM */
    lastShow = show;
    buyBar.classList.toggle('show', show);
    buyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.documentElement.classList.toggle('tx-buybar-visible', show);
  }

  /* ---------- 每帧驱动 ----------
     只做显隐判断，不再用 JS 改 top/bottom。iOS 真机滚动时 visualViewport 数值会抖，
     逐帧追位置会让 Choose Your Kit 快速跳动；底部固定交回 CSS 的 fixed bottom。 */
  if(buyBar){
    (function buyBarFrame(){
      updateBuyBarVis();
      requestAnimationFrame(buyBarFrame);
    })();
  }

  /* ---------- Choose Your Kit / Start Risk-Free：共享滚动落屏 ----------
     tx2 页以 ADD TO CART 下方安全提示（.tx2-hero__safe）作为落屏底边，距离真实
     可视屏幕底边 12px，找不到时以 [data-tx2-cta] 兜底；点击后立即隐藏 sticky bar，
     平滑滚动途中也不允许两个主按钮同时出现。两个入口共用这一份计算，不再各写一套。 */
  function hideBuyBarForScroll(){
    window.__txBuyBarSuppressUntil = Date.now() + 1800;
    if(buyBar){
      buyBar.classList.remove('show');
      buyBar.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('tx-buybar-visible');
    lastShow = false;
  }
  function scrollToTx2Offer(){
    var addToCartBtn = document.querySelector('[data-tx2-cta]');
    var safeLine = document.querySelector('.tx2-hero__safe');
    var landingEnd = (safeLine && safeLine.getClientRects().length) ? safeLine : addToCartBtn;
    if(!landingEnd){ return false; }   /* 非 tx2 页：交回调用方的后备跳转 */
    function landingTop(){
      var vv = window.visualViewport;
      var viewTop = vv ? vv.offsetTop : 0;
      var viewHeight = vv ? vv.height : (document.documentElement.clientHeight || window.innerHeight);
      var endBottom = landingEnd.getBoundingClientRect().bottom + window.pageYOffset;
      /* 安全提示离屏幕底边留 12px，ADD TO CART 会自然落在它上方。 */
      return Math.max(0, endBottom - viewTop - viewHeight + 12);
    }
    window.scrollTo({ top: landingTop(), behavior: 'smooth' });
    /* iOS 工具栏可能在 smooth scroll 结束时改变可视高度，结束后校正一次落点；
       viewTop/viewHeight 均取自 visualViewport，iPhone Chrome 同样适用。 */
    window.setTimeout(function(){
      var settledTop = landingTop();
      if(Math.abs(window.pageYOffset - settledTop) > 3){
        window.scrollTo({ top: settledTop, behavior: 'auto' });
      }
    }, 900);
    return true;
  }
  document.addEventListener('click', function(e){
    var kitCta = e.target.closest('#txBuyBarCta');
    var offerCta = kitCta || e.target.closest('[data-tx-offer-cta]');
    if(!offerCta) return;
    e.preventDefault();
    hideBuyBarForScroll();
    if(scrollToTx2Offer()) return;
    /* 非 tx2 页后备：Choose Your Kit 回原有选档区；Start Risk-Free 走自身锚点。 */
    if(kitCta){
      var fallback = document.querySelector('.kaching-bundles__block') || document.getElementById('pack-tiers');
      var top = fallback ? Math.max(0, fallback.getBoundingClientRect().top + window.pageYOffset - 76) : 0;
      window.scrollTo({ top: top, behavior: 'smooth' });
    } else {
      var anchorTarget = getAnchorTarget(offerCta.getAttribute('href'));
      if(anchorTarget){ scrollToAnchor(anchorTarget); }
    }
  });

  /* ---------- before/after marquee: clone combos once for a seamless loop ---------- */
  var baTrack = root.querySelector('#baMarquee');
  if(baTrack && !reduce){
    var combos = [].slice.call(baTrack.children);
    combos.forEach(function(node){
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      baTrack.appendChild(clone);
    });
  }

  /* ---------- Social videos: click to play (no autoplay, no preload) ----------
     Nothing downloads until the user taps a card's play button — fast first paint.
     One video plays at a time (starting one pauses the others). Sound is on,
     since the click is a user gesture; if the browser still blocks it we retry muted. */
  var tkCards = [].slice.call(root.querySelectorAll('[data-tk-card]'));
  if(tkCards.length){
    var PLAY_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5.3c0-1.7 1.8-2.8 3.3-2L20.7 10c1.6.9 1.6 3.1 0 3.9L8.3 20.7C6.8 21.5 5 20.4 5 18.7V5.3z" fill="currentColor"/></svg>';
    var tkData = [];
    function tkHasSrc(v){ return v && (v.getAttribute('src') || v.querySelector('source[src]')); }
    function tkStopOthers(except){
      tkData.forEach(function(d){
        if(d.card === except) return;
        if(d.v && !d.v.paused){ d.v.pause(); }
        d.card.classList.remove('playing');
        if(d.ph){ d.ph.classList.remove('hidden'); }
      });
    }
    tkCards.forEach(function(card){
      var v = card.querySelector('[data-tk-video]');
      if(!v || !tkHasSrc(v)) return;
      v.preload = 'none'; v.loop = true; v.muted = false; v.removeAttribute('autoplay');
      var ph = card.querySelector('.tk-ph');
      var d = { card: card, v: v, ph: ph };
      tkData.push(d);
      function start(){
        tkStopOthers(card);
        if(v.preload !== 'auto'){ v.preload = 'auto'; }
        v.muted = false;
        var p = v.play();
        if(p && p.catch){ p.catch(function(){ v.muted = true; var p2 = v.play(); if(p2 && p2.catch){ p2.catch(function(){}); } }); }
        card.classList.add('playing');
        if(ph){ ph.classList.add('hidden'); }
      }
      function stop(){ v.pause(); card.classList.remove('playing'); if(ph){ ph.classList.remove('hidden'); } }
      var pbtn = document.createElement('button');
      pbtn.type = 'button'; pbtn.className = 'vplay'; pbtn.setAttribute('aria-label', 'Play video');
      pbtn.innerHTML = PLAY_SVG;
      (v.parentElement || card).appendChild(pbtn);
      pbtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); start(); });
      if(ph){ ph.addEventListener('click', function(){ start(); }); }
      v.addEventListener('click', function(){ if(v.paused){ start(); } else { stop(); } });
      v.addEventListener('ended', function(){ if(!v.loop){ stop(); } });
    });
  }

  /* ---------- Silent results reel: load + play only when scrolled into view ----------
     Uses a scroll/resize visibility check (not IntersectionObserver, which can be
     unreliable inside some embedded/preview environments). Still lazy: the video file
     isn't fetched until the section is near the viewport. */
  var autoVids = [].slice.call(root.querySelectorAll('[data-autoplay-video]'));
  if(autoVids.length){
    if(reduce){
      autoVids.forEach(function(v){ v.preload = 'metadata'; });
    } else {
      var avInView = function(v){
        var r = v.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        return r.bottom > h * 0.12 && r.top < h * 0.88;
      };
      var avTick = function(){
        autoVids.forEach(function(v){
          if(avInView(v)){
            if(v.preload !== 'auto'){ v.preload = 'auto'; }
            if(v.paused){ v.muted = true; var p = v.play(); if(p && p.catch){ p.catch(function(){}); } }
          } else if(!v.paused){ v.pause(); }
        });
      };
      addScrollJob(avTick);
      avTick();
    }
  }

  /* ---------- smooth-scroll for in-page anchors ---------- */
  function getAnchorTarget(id){
    if(!id || id.length < 2){ return null; }
    try { return root.querySelector(id); }
    catch(e){ return document.getElementById(id.slice(1)); }
  }

  function getTopScrollOffset(){
    var selectors = [
      '.section-header.shopify-section-header-sticky:not(.shopify-section-header-hidden)',
      '.shopify-section-header-sticky:not(.shopify-section-header-hidden)',
      '.announcement-bar-section',
      '.shopify-section-group-header-group'
    ].join(',');
    var obstructionBottom = 0;
    [].slice.call(document.querySelectorAll(selectors)).forEach(function(el){
      if(!el || el.classList.contains('shopify-section-header-hidden')) return;
      var style = window.getComputedStyle(el);
      var pos = style.position;
      if(pos !== 'fixed' && pos !== 'sticky') return;
      if(pos === 'sticky' && style.top === 'auto') return;
      var rect = el.getBoundingClientRect();
      if(rect.height < 1 || rect.bottom <= 0 || rect.top > 2) return;
      obstructionBottom = Math.max(obstructionBottom, rect.bottom);
    });
    return Math.max(12, Math.ceil(obstructionBottom) + 12);
  }

  function scrollToAnchor(target){
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        var previousMargin = target.style.scrollMarginTop;
        target.style.scrollMarginTop = getTopScrollOffset() + 'px';
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start', inline: 'nearest' });
        window.setTimeout(function(){
          if(previousMargin){ target.style.scrollMarginTop = previousMargin; }
          else { target.style.removeProperty('scroll-margin-top'); }
        }, reduce ? 0 : 1200);
      });
    });
  }

  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    if(a.hasAttribute('data-tx-offer-cta')){ return; }  /* 由上方共享落屏逻辑接管 */
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      var target = getAnchorTarget(id);
      if(target){
        e.preventDefault();
        scrollToAnchor(target);
      }
    });
  });
  }
  /* ---------- theme editor: 处理 init 之后才添加的区块 ----------
     init() 只跑一次（被 __txSalesInit 守卫）。若不处理，编辑器里后添加的区块会一直
     停在 .reveal 的 opacity:0 → 整段空白。每次 section 加载时：给它打开 .tx-animate
     并把其中的 .reveal 揭示出来；若 init 还没跑过则先跑 init。监听器只注册一次。 */
  if(!window.__txSalesSectionHook){
    window.__txSalesSectionHook = true;
    document.addEventListener('shopify:section:load', function(e){
      if(!window.__txSalesInit){ init(); return; }
      var sec = (e && e.target) ? e.target : document;
      [].slice.call(sec.querySelectorAll('.tx-sales')).forEach(function(s){ s.classList.add('tx-animate'); });
      var rs = [].slice.call(sec.querySelectorAll('.reveal'));
      requestAnimationFrame(function(){ rs.forEach(function(el){ el.classList.add('in'); }); });
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
